import { 
    findOrdersByCompanyAndSeller, 
    findOrdersByCompanyAndSellerGroupDate, 
    findOrdersByCompanyAndSellerGroupClient 
} from '../../_services/order.service';

export const findSellerOrdersEvent = async () => {
    let res = await findOrdersByCompanyAndSeller();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findSellerOrdersGroupDateEvent = async (year, month) => {
    let res = await findOrdersByCompanyAndSellerGroupDate(year, month);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findSellerOrdersGroupClientEvent = async () => {
    let res = await findOrdersByCompanyAndSellerGroupClient();
    if(! res.ok) throw new Error(res.error);
    return res;
}